import { render, staticRenderFns } from "./editOaWorkflow.vue?vue&type=template&id=c81340ca"
import script from "./editOaWorkflow.vue?vue&type=script&lang=js"
export * from "./editOaWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports